import React from 'react'
import Highlight, {defaultProps} from 'prism-react-renderer'
import theme from "prism-react-renderer/themes/nightOwl";

const CodeBlock = (props) => {
    const className = props.children.props.className || ''
    const matches = className.match(/language-(?<lang>.*)/)
  return (
    <Highlight {...defaultProps} code={props.children.props.children.trim()} language={
        matches && matches.groups && matches.groups.lang
          ? matches.groups.lang
          : ''
      }
      theme={theme}>
      {({className, style, tokens, getLineProps, getTokenProps}) => {   
        return (
        <pre className={className} style={{...style, padding: '20px'}}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({line, key: i})}>
              {line.map((token, key) => (
                // For some reason, I had to pass a blank className prop to the result of `getTokenProps`
                // to remove a `tag` className that was always getting appended 
                <span key={key} {...{...getTokenProps({token, key}), className: ""}} />
              ))}
            </div>
          ))}
        </pre>
      )}
      }
    </Highlight>
  )
}

export default CodeBlock;